import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { persistQueryClient } from "@tanstack/react-query-persist-client";

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 60 * 1000, // Data is considered fresh for 30 minutes
      gcTime: 2 * 60 * 60 * 1000, // Cache is kept for 2 hours
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: 1, // Only retry failed requests once
    },
  },
});

// Create a persister that uses localStorage
const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

// Persist the cache
persistQueryClient({
  queryClient,
  persister,
  maxAge: 2 * 60 * 60 * 1000, // 2 hours
  buster: "v1", // Cache version - increment this when you want to invalidate all cached data
});

// Helper function to generate cache keys
export const cacheKeys = {
  lot: {
    all: ["lots"] as const,
    detail: (lotId: string) => ["lot", lotId] as const,
    analytics: (lotId: string, startDate: string, endDate: string) =>
      ["lot", lotId, "analytics", startDate, endDate] as const,
    hourly: (lotId: string, date: string) =>
      ["lot", lotId, "hourly", date] as const,
    devices: (lotId: string) => ["lot", lotId, "devices"] as const,
    sessions: (lotId: string) => ["lot", lotId, "sessions"] as const,
  },
};
